import { css, type Theme } from "@mui/material";

// Define your styles using Emotion
// TODO upravit v tématu
export const datePickerFieldStyles = (props: { theme: Theme }) => css`
  .MuiInputBase-root {
    font-size: 16px;
    font-weight: 600;
    padding: ${props.theme.spacing(0.5, 1.4)};
    border-radius: ${props.theme.borderRadius};
    border-width: 1px;

    &:before,
    &:after {
      content: none;
    }

    &:hover {
      border-color: ${props.theme.palette.text.primary};
    }

    &.Mui-focused {
      border-color: ${props.theme.palette.primary.main};
    }

    .MuiIconButton-root {
      color: ${props.theme.palette.primary.main};
      padding: 8px;
    }

    &.Mui-error {
      border-color: ${props.theme.palette.deprecated.error.main};
    }
  }

  .MuiTouchRipple-root {
    color: ${props.theme.palette.primary.main};
  }

  .MuiInputBase-input {
    padding: ${props.theme.spacing(0.7, 0)};
    &::placeholder {
      opacity: 1;
    }
  }

  // this is a fix for overflowing the input width and causing the Quick Task form to break
  .MuiPickersInputBase-sectionsContainer {
    width: auto;
  }
`;
